import { render, staticRenderFns } from "./site-config.vue?vue&type=template&id=26e42401&scoped=true&"
import script from "./site-config.vue?vue&type=script&lang=ts&"
export * from "./site-config.vue?vue&type=script&lang=ts&"
import style0 from "./site-config.vue?vue&type=style&index=0&id=26e42401&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e42401",
  null
  
)

component.options.__file = "site-config.vue"
export default component.exports